export const updateCertficate = ({ BeURL, id, certifications, setCertificate, showAlert }) => {
    fetch(`${BeURL}/candidate-certificate/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ certifications }),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setCertificate(data.certificate)
            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in Adding Experience", err);
        });
}
